<template>
  <div
    v-observe-visibility="{ callback: visibilityChanged, once: true }"
    class="ui grid header group-header"
  >
    <div class="sixteen wide column">
      <h3
        class="ui header group-header-title"
        :class="{ pointer: collapsible }"
        @click="toggle"
      >
        <span class="group-header-name">{{ title }}</span>
        <span class="group-header-count">{{ count }}</span>
        <i
          v-if="collapsible"
          class="icon caret grey small group-header-caret"
          :class="{ right: collapsed, down: !collapsed }"
        />
      </h3>

      <div class="ui divider" />

      <div v-if="chartData" class="ui three column stackable grid group-header-stats">
        <div
          v-for="type in ['impressions', 'views', 'engagements']"
          v-if="chartData[type]"
          :key="type"
          class="column"
        >
          <div class="ui grid row">
            <div class="four wide column centered">
              <pie-chart
                height="50px"
                :legend="false"
                :donut="true"
                :colors="chartColors(type)"
                :data="chartData[type]"
              />
            </div>
            <div class="twelve wide column">
              <div class="ui statistic tiny left aligned">
                <div class="value">
                  {{ statsTotals(type) | abbreviateNumber(10000000) }}
                </div>
                <div class="label">{{ type | humanize }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.esm";
import Chartkick from "chartkick";
import VueChartkick from "vue-chartkick";
import { map, sum } from "lodash";
import { mapState } from "vuex";
import store from "store";
import VueObserveVisibility from "vue-observe-visibility";
import "functions/filters";

Vue.use(VueObserveVisibility);
Vue.use(VueChartkick, { Chartkick });

const $ = window.jQuery;

export default {
  store,
  props: {
    title: {
      type: String,
      default: "",
    },
    deliverables: {
      type: Array,
      default() {
        return [];
      },
    },
    count: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: "",
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartData: null,
    };
  },
  computed: {
    ...mapState("deliverable", { colors: "colors" }),
    ...mapState("report", ["report"]),
    deliverableIds() {
      // YouTube metrics are not aggregated alongside other channels (matches
      // the per-creator header behaviour).
      return map(
        this.deliverables.filter((d) => d.inferred_type !== "youtube"),
        "id"
      );
    },
  },
  methods: {
    toggle() {
      if (this.collapsible) this.$emit("toggle");
    },
    visibilityChanged(isVisible) {
      if (isVisible) this.loadChartData();
    },
    loadChartData() {
      if (this.chartData || this.deliverableIds.length === 0) return;
      $.ajax({
        url: `/statistics/pie_chart_data?deliverable_ids=${this.deliverableIds}&report_id=${this.report.id}&access_token=${this.report.access_token}`,
      }).then((data) => {
        this.chartData = data;
      });
    },
    statsTotals(type) {
      return sum(Object.values(this.chartData[type]));
    },
    chartColors(type) {
      return Object.keys(this.chartData[type]).map((k) => this.colors[k]);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-header {
  margin-top: 1.5rem;
}

.group-header-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.group-header-name {
  font-size: 1.15rem;
}

.group-header-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.45rem;
  border-radius: 999px;
  background: rgba(244, 128, 111, 0.12);
  color: #c85a46;
  font-size: 0.78rem;
  font-weight: 700;
}

.group-header-caret {
  margin-left: auto;
}

.group-header-stats {
  margin-top: 0.25rem;
}
</style>
